/**
 * `gameFlag` resolution for `VIFRulesAddSub`.
 *
 * Extracted verbatim from `VIFRulesAddSub.computeGameFlag` so the CreateJS
 * game and the DOM board resolve variants identically. `moduleId` alone is not
 * sufficient - 166 routes to the 4x4 block board or the 3x3 rules board
 * depending on `moduleVariant`.
 *
 * Flags 0-5 are addition, 6-12 subtraction (`computeOperation` is
 * `gameFlag > 5 ? SUB : ADD`).
 */

/** `${moduleId}:${moduleVariant}` -> gameFlag. */
const FLAG_BY_MODULE: Readonly<Record<string, number>> = {
  '170:0': 0,
  '170:1': 1,
  '170:2': 2,
  '178:0': 3,
  '178:1': 4,
  '166:1': 5,
  '171:0': 6,
  '171:1': 7,
  '171:2': 8,
  '179:0': 9,
  '179:1': 10,
  '167:1': 11,
  '167:2': 12,
};

/**
 * Resolves the rules add/sub `gameFlag`.
 *
 * `fallback` is kept separate from `moduleVariant` on purpose: the legacy code
 * seeds `let gameFlag = moduleVariant` from the *parameter* while every lookup
 * branch tests `gameFrame.moduleVariant`. Those two are normally equal, but
 * collapsing them would silently change behaviour where they are not.
 */
export function resolveRulesAddSubGameFlag(
  moduleId: number,
  moduleVariant: number,
  fallback: number = moduleVariant,
): number {
  return lookupRulesAddSubGameFlag(moduleId, moduleVariant) ?? fallback;
}

/**
 * Strict lookup: `null` when the module/variant pair is not in the table.
 *
 * Routing decisions must use this rather than `resolveRulesAddSubGameFlag`.
 * The lenient fallback exists only to preserve legacy canvas behaviour, and it
 * maps any unmapped variant 0-5 onto an addition flag - which would quietly
 * route unrelated modules to the DOM board.
 */
export function lookupRulesAddSubGameFlag(
  moduleId: number,
  moduleVariant: number,
): number | null {
  return FLAG_BY_MODULE[`${moduleId}:${moduleVariant}`] ?? null;
}
